import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/system-management/roles')({
  component: Outlet,
  head: () => ({ meta: [{ title: '角色权限 · Super Mega' }] })
})
